import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
const faqs = [{
  q: '¿Puedo hacerlo si tuve cesárea?',
  a: 'Sí, una vez la cicatriz sane y tengas el alta médica.'
}, {
  q: '¿Funciona si pasaron 5 años desde mi parto?',
  a: 'Absolutamente, el músculo tiene memoria y puede rehabilitarse.'
}, {
  q: '¿Necesito equipo?',
  a: 'Ninguno, solo un espacio pequeño en el suelo o tu cama.'
}, {
  q: '¿Es seguro si estoy lactando?',
  a: 'Totalmente seguro y recomendado.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 bg-white" data-id="element-32">
      <div className="max-w-3xl mx-auto px-5 lg:px-8" data-id="element-33">
        <div className="text-center mb-8 md:mb-16" data-id="element-34">
          <h2 className="text-2xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-35">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-px bg-rosegold mx-auto" data-id="element-36"></div>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-37">
          {faqs.map((faq, index) => <div key={index} className="border border-rosegold/20 rounded-lg overflow-hidden" data-id="element-38">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-6 text-left bg-cream/50 hover:bg-cream transition-colors" data-id="element-39">
                <span className="font-serif text-base md:text-lg text-charcoal pr-4" data-id="element-40">
                  {faq.q}
                </span>
                <svg className={`w-5 h-5 text-rosegold transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-41">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-42" />
                </svg>
              </button>
              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44">
                    <div className="p-4 md:p-6 pt-0 bg-cream/50 text-charcoal/70 leading-relaxed text-sm md:text-base" data-id="element-45">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="text-center mt-8 md:mt-12" data-id="element-46">
          <CTAButton className="w-full md:w-auto" data-id="element-47">
            ¡SÍ, QUIERO RECUPERAR MI FUERZA!
          </CTAButton>
        </div>
      </div>
    </section>;
}